module.exports = __webpack_public_path__ + "assets/images/ote_sport_3.98261cf3852ef0f73bdc31135f5f4c72.png";